var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-pulse",class:_vm.modifyClass},[_c('div',{staticClass:"dot-pulse__item"}),_c('div',{staticClass:"dot-pulse__item"}),_c('div',{staticClass:"dot-pulse__item"})])
}
var staticRenderFns = []

export { render, staticRenderFns }